import {FilterContrastProvider, useInvertedSurface} from '@hconnect/common/styles'
import {BackToLink, PageTitle} from '@hconnect/uikit/src/lib2'
import {Box, Stack} from '@mui/material'
import {ReactNode} from 'react'
import {useNavigate} from 'react-router'

type StatusPageHeaderProps = {
  title: ReactNode
  backButtonProps?: {
    targetName: string
    target?: string
    onClick?: () => void
  }
  filterComponent?: ReactNode
  afterTitle?: ReactNode
}

export const StatusPageHeader = ({
  title,
  backButtonProps,
  filterComponent,
  afterTitle
}: StatusPageHeaderProps) => {
  const navigate = useNavigate()
  const inverted = useInvertedSurface()

  const handleNavigate = (target: string) => {
    backButtonProps?.onClick?.()

    if (!backButtonProps?.target) return

    void navigate(target, {relative: 'path'})
  }

  return (
    <Stack
      direction={{xs: 'column', sm: 'row'}}
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      mb={3}
    >
      <Box display="flex" flexDirection="column" mr="auto">
        {backButtonProps && (
          <BackToLink
            navigate={handleNavigate}
            targetName={backButtonProps.targetName}
            target={backButtonProps.target ?? ''}
          />
        )}
        <PageTitle
          mx={3}
          mb={!backButtonProps ? 3 : 0}
          sx={{display: 'inline-flex', alignItems: 'center'}}
          className={inverted ? 'text-foreground_inverted' : 'text-foreground'}
          data-test-id="page-title"
        >
          {title}
        </PageTitle>
        {afterTitle}
      </Box>
      {filterComponent && (
        <Box
          display="flex"
          flexDirection={{xs: 'column', sm: 'row'}}
          justifyContent="space-between"
          gap={1}
          m={{xs: 2, sm: 0}}
        >
          <FilterContrastProvider isContrastMode={inverted}>
            {filterComponent}
          </FilterContrastProvider>
        </Box>
      )}
    </Stack>
  )
}
